'use client'

import { HTMLMotionProps, motion } from 'framer-motion'
import { cn } from '@/lib/utils'
import { ReactNode } from 'react'

interface NeonButtonProps extends Omit<HTMLMotionProps<"button">, "ref"> {
  children: ReactNode
  variant?: 'primary' | 'secondary'
}

export function NeonButton({ 
  children, 
  className, 
  variant = 'primary', 
  disabled,
  ...props 
}: NeonButtonProps) {
  const variants = {
    primary: "bg-gradient-to-r from-neon-pink to-neon-purple text-white font-bold shadow-[0_0_30px_rgba(255,45,149,0.4)] hover:shadow-[0_0_50px_rgba(255,45,149,0.6)] hover:scale-[1.02]",
    secondary: "bg-transparent border-2 border-neon-cyan text-neon-cyan hover:bg-neon-cyan/10 hover:shadow-[0_0_30px_rgba(0,229,255,0.3)]"
  }

  return (
    <motion.button
      whileTap={!disabled ? { scale: 0.98 } : undefined}
      className={cn(
        "inline-flex items-center justify-center gap-3 rounded-2xl px-8 py-4 text-base transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed",
        variants[variant],
        className
      )}
      disabled={disabled}
      {...props}
    >
      {children}
    </motion.button>
  )
}
